export const formatUSPhone = (value: string | number) => {
  if (!value) return "";

  const digits = value.toString().replace(/\D/g, "").slice(0, 10);

  if (digits.length < 4) return digits;
  if (digits.length < 7)
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

export const getUSPhoneDigits = (value: string) =>
  value.replace(/\D/g, "").slice(0, 10);